import { Body, Controller, Post } from "@nestjs/common";
import { ApiBody, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { EmployeeBuyerMappingService } from "./employee-buyer-mapping.service";
import {  BuyerID, CommonResponseModel, EmployeeBuyerMapppingResponseModel } from "@project-management-system/shared-models";
import { EmployeeBuyerMappingDto } from "./employee-buyer-mapping-dto";
import { EmployeeBuyerMappingRequest } from "./employee-buyer-mapping-req";

@ApiTags('employee_buyer_mapping')
@Controller('employee_buyer_mapping')
export class EmployeeBuyerMappingController {
    constructor(
        private employeeBuyerMappingService: EmployeeBuyerMappingService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }

    @Post('/createEmployeeBuyerMapping')
    @ApiBody({type:EmployeeBuyerMappingDto})
    async createEmployeeBuyerMapping(@Body() req:any): Promise<EmployeeBuyerMapppingResponseModel> {
        console.log(req,'llll');
        
        try {
            return await this.employeeBuyerMappingService.createEmployeeBuyerMapping(req,false);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EmployeeBuyerMapppingResponseModel, error)
        }
    }

    @Post('/updateEmployeeBuyerMapping')
    async updateEmployeeBuyerMapping(@Body() req:any): Promise<EmployeeBuyerMapppingResponseModel> {
        try {
            return await this.employeeBuyerMappingService.createEmployeeBuyerMapping(req,true);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EmployeeBuyerMapppingResponseModel, error)
        }
    }

    @Post('/getAllEmployees')
    async getAllEmployees(req:BuyerID): Promise<EmployeeBuyerMapppingResponseModel> {
        try {
            return await this.employeeBuyerMappingService.getAllEmployees(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EmployeeBuyerMapppingResponseModel, error)
        }
    }

    @Post('/activateOrDeactivateEmployeeBuyer')
    @ApiBody({type:EmployeeBuyerMappingRequest})
    async activateOrDeactivateEmployeeBuyer(@Body() req:any): Promise<EmployeeBuyerMapppingResponseModel> {
        try {
            return await this.employeeBuyerMappingService.activateOrDeactivateEmployeeBuyer(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EmployeeBuyerMapppingResponseModel, error)
        }
    }

    @Post('/getAllActiveBuyers')
    async getAllActiveBuyers(req:any): Promise<EmployeeBuyerMapppingResponseModel> {
        try {
            return await this.employeeBuyerMappingService.getAllActiveBuyers();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EmployeeBuyerMapppingResponseModel, error)
        }
    }
    @Post('/getAllEmployeeMapping')
    @ApiBody({type:BuyerID})
    async getAllEmployeeMapping(@Body() req: any): Promise<EmployeeBuyerMapppingResponseModel> {
        try {
            console.log(req,'000000000000000000')
            return await this.employeeBuyerMappingService.getAllEmployeeMapping(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(EmployeeBuyerMapppingResponseModel, error)
        }
    }

    @Post('/getMappedBuyers')
    @ApiBody({type:BuyerID})
    async getMappedBuyers(@Body() req: any): Promise<CommonResponseModel> {
        try {
            console.log(req,'000000000000000000')
            return await this.employeeBuyerMappingService.getMappedBuyers(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponseModel, error)
        }
    }

}